import {ReactElement} from 'react'
import {UnlockYourTradingPotentialBanner} from './components/UnlockYourTradingPotentialBanner'
import {BannersCarouselProps} from './types'

type GetBannerSlidesInput = BannersCarouselProps

export function getBannerSlides({company, isClientEligible}: GetBannerSlidesInput): ReactElement[] {
  return [<UnlockYourTradingPotentialBanner />]
}
